import { useState, useRef } from 'react';
import clsx from 'clsx';
import Transition from 'react-transition-group/Transition';
import { PaletteUtils } from '@shared/utils';
import { Burger } from './burger';
import { UserInfo } from './userInfo';
import { Nav } from '../nav';
import { Logout } from './logout';
import { Logo } from '@shared/widgets';

interface HeaderProps {
  className?: string;
}

export const Header = (props: HeaderProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const nodeRef = useRef<HTMLDivElement>(null);

  return (
    <Transition in={open} timeout={0} nodeRef={nodeRef}>
      <div
        ref={nodeRef}
        className={clsx(
          'select-none h-[70px] max-[840px]:h-0',
          PaletteUtils.isBordierPalette ? 'bg-white border-b border-b-[#e6e6e6]' : 'bg-[#1e1e21]',

          props.className,
        )}
      >
        <div
          className={clsx(
            'h-full max-w-[1280px] mx-auto px-[10px] relative flex items-center transition-[left] duration-300',
            'max-[840px]:fixed max-[840px]:z-[200] max-[840px]:top-15 max-[840px]:bottom-0 max-[840px]:m-0 max-[840px]:h-auto max-[840px]:max-w-full max-[840px]:bg-[#27272b] max-[840px]:py-[22px] max-[840px]:flex-col max-[840px]:px-0 max-[840px]:items-start max-[840px]:w-[300px] !z-[1002]',
            !open ? 'max-[840px]:!left-[-100%]' : 'max-[840px]:left-0',
          )}
        >
          <Burger isOpen={open} onClick={() => setOpen((prev) => !prev)} />
          <Logo className='max-[840px]:hidden mr-10' />
          <UserInfo />
          <Nav onClick={() => setOpen(false)} />
          <Logout />
        </div>
        <div
          className={clsx('fixed z-40 left-0 top-0 right-0 bottom-0 bg-[#1e1e21]/80', !open ? 'hidden' : 'block')}
          onClick={() => setOpen((prev) => !prev)}
        />
      </div>
    </Transition>
  );
};
